import React from 'react';

function Introduction() {
  return (
    <section id="intro" style={{ 
      display: 'flex', 
      gap: '40px', 
      alignItems: 'stretch', 
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      background: 'transparent'
    }}>
      <div style={{ 
        flex: 1, 
        minWidth: '320px',
        animation: 'slideInLeft 0.8s ease-out'
      }}>
        <h2 style={{ textAlign: 'left', marginBottom: '24px', color: 'var(--text-primary)' }}>About Dabra</h2>
        <div className="glass-card" style={{ 
          padding: '40px',
          textAlign: 'left'
        }}>
          <p style={{ 
            fontSize: '1.05rem',
            lineHeight: '1.8',
            marginBottom: '18px',
            color: '#4a5568'
          }}>
            Dabra is a research-heavy applied AI team founded by builders with backgrounds in data science,
            software engineering, and healthcare innovation. We focus on turning rigorous research into
            production-ready systems that teams can trust.
          </p>

          <p style={{ 
            fontSize: '1.05rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#4a5568'
          }}>
            Our mission is simple: help organizations unlock real value from complex data through compliant,
            scalable AI solutions. From pilot studies to full deployment, we prioritize measurable outcomes,
            transparent collaboration, and long-term impact.
          </p>
          
          {/* Key differentiators */}
          <div style={{ 
            marginTop: '30px'
          }}>
            <h4 style={{
                fontSize: '1rem',
                fontWeight: '600',
                color: '#2d3748',
                marginBottom: '15px'
              }}>
                Our Approach:
              </h4>
              {['Applied Research', 'Compliance-first Design', 'Partnership & Impact'].map((area, index) => (
              <div key={area} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '10px',
                animation: `slideInUp 0.6s ease-out ${0.2 + index * 0.1}s both`
              }}>
                <div style={{
                  width: '6px',
                  height: '6px',
                  background: '#2d3748',
                  borderRadius: '50%'
                }}></div>
                <span style={{
                  fontSize: '0.95rem',
                  color: '#4a5568',
                  fontWeight: '500'
                }}>
                  {area}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div style={{ 
        flex: 1, 
        minWidth: '320px',
        animation: 'slideInRight 0.8s ease-out 0.2s both'
      }}>
        <div className="glass-card" style={{ 
          padding: '40px',
          textAlign: 'center',
          position: 'relative'
        }}>
          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: '600',
            color: '#2d3748',
            marginBottom: '30px'
          }}>
            Platform Overview
          </h3>
          
          {/* Platform schema */}
          <div style={{
            width: '100%',
            height: 'auto',
            marginBottom: '20px',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
          }}>
            <img 
              src="/platform.png" 
              alt="Dabra Platform Architecture - Multimodal Data Processing" 
              style={{ 
                width: '100%', 
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
          
          <p style={{
            fontSize: '0.9rem',
            color: '#718096',
            fontStyle: 'italic',
            margin: 0
          }}>
            "Narrow AI feature extraction from multimodal data with intelligent agent analysis"
          </p>
          <div style={{ marginTop: '18px' }}>
            <a href="https://www.dabra.bio" target="_blank" rel="noopener noreferrer" className="hero-cta hero-cta-outline">View Live App</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Introduction;
